import { render, staticRenderFns } from "./CarrosselHero.vue?vue&type=template&id=154977a8"
import script from "./CarrosselHero.vue?vue&type=script&lang=js"
export * from "./CarrosselHero.vue?vue&type=script&lang=js"
import style0 from "./CarrosselHero.vue?vue&type=style&index=0&id=154977a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports